import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import axios from 'axios';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import 'leaflet-geosearch/dist/geosearch.css';

// Import the custom location icon
import Location from '../assets/icons/location.svg';

// Fix Leaflet's default icon paths
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

// Define a custom marker icon using the imported SVG
const customIcon = new L.Icon({
  iconUrl: Location,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

const MapComponent = ({ lat, lng, onSelect }) => {
  const [position, setPosition] = useState([lat || 35.6892, lng || 51.3890]); // Default to Tehran if no lat/lng is passed
  const [address, setAddress] = useState('');

  useEffect(() => {
    if (lat && lng) {
      setPosition([lat, lng]);
      fetchAddress({ lat, lng });
    }
  }, [lat, lng]);

  // Fetch address using reverse geocoding in Persian
  const fetchAddress = async ({ lat, lng }) => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=fa`
      );
      if (response.data && response.data.address) {
        const { city, town, village, neighbourhood, road, residential, province } = response.data.address;
        const addressParts = [];
        if (province) addressParts.push(province);
        if (city || town || village) addressParts.push(city || town || village);
        if (neighbourhood) addressParts.push(neighbourhood);
        if (road) addressParts.push(road);
        if (residential) addressParts.push(residential);
        const fullAddress = addressParts.join(', ');
        setAddress(fullAddress);
        onSelect(fullAddress, lat, lng); // Pass the address to the parent
      }
    } catch (error) {
      console.error('Error fetching address', error);
    }
  };

  const LocationMarker = () => {
    useMapEvents({
      click(e) {
        const { lat, lng } = e.latlng;
        setPosition([lat, lng]);
        fetchAddress({ lat, lng });
      },
    });

    return <Marker position={position} icon={customIcon}></Marker>;
  };

  const MapWithControl = () => {
    const map = useMap();

    useEffect(() => {
      const provider = new OpenStreetMapProvider({
        params: {
          'accept-language': 'fa', // Set language to Persian
        },
      });

      const searchControl = new GeoSearchControl({
        provider,
        style: 'bar',
        autoComplete: true,
        autoCompleteDelay: 250,
        showMarker: false, // Disable default marker
      });

      map.addControl(searchControl);

      map.on('geosearch/showlocation', (result) => {
        if (result?.location?.lat !== undefined && result?.location?.lng !== undefined) {
          const { lat, lng } = result.location;
          setPosition([lat, lng]);
          fetchAddress({ lat, lng });
        } else {
          console.error('Invalid location data:', result);
        }
      });

      return () => map.removeControl(searchControl);
    }, [map]);

    return null;
  };

  return (
    <div>
      <MapContainer
        center={position}
        zoom={13}
        style={{ height: '400px', width: '100%' }}
      >
        <TileLayer
          url="https://mt0.google.com/vt/lyrs=m@132&hl=fa&x={x}&y={y}&z={z}"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          minZoom={0}
          maxZoom={22}
        />
        <LocationMarker />
        <MapWithControl />
      </MapContainer>
      <p>آدرس انتخاب‌شده: {address}</p>
    </div>
  );
};

export default MapComponent;
